/** API may return UserScope as numeric enum or string (JsonStringEnumConverter). */
export type UserScopeValue = number | string | null | undefined;

export const USER_SCOPE = {
  System: 1,
  Marina: 2,
  Client: 3,
} as const;

export type UserScopeId = (typeof USER_SCOPE)[keyof typeof USER_SCOPE];

export const USER_SCOPE_OPTIONS: ReadonlyArray<{ value: UserScopeId; label: string }> = [
  { value: USER_SCOPE.System, label: 'System' },
  { value: USER_SCOPE.Marina, label: 'Marina' },
  { value: USER_SCOPE.Client, label: 'Client' },
];

/** Normalize API userScope to 1 | 2 | 3, or null when unknown/missing. */
export function normalizeUserScope(scope: UserScopeValue): UserScopeId | null {
  if (scope == null || scope === '') return null;

  if (typeof scope === 'number' && !Number.isNaN(scope)) {
    if (scope === 1 || scope === 2 || scope === 3) return scope;
    return null;
  }

  const raw = String(scope).trim();
  if (/^[123]$/.test(raw)) {
    return Number(raw) as UserScopeId;
  }

  switch (raw.toLowerCase()) {
    case 'system':
      return USER_SCOPE.System;
    case 'marina':
      return USER_SCOPE.Marina;
    case 'client':
      return USER_SCOPE.Client;
    default:
      return null;
  }
}

export function getUserScopeLabel(scope: UserScopeValue): string {
  switch (normalizeUserScope(scope)) {
    case USER_SCOPE.System:
      return 'System';
    case USER_SCOPE.Marina:
      return 'Marina';
    case USER_SCOPE.Client:
      return 'Client';
    default:
      return 'Unknown';
  }
}

export function isUserScope(scope: UserScopeValue, expected: UserScopeId): boolean {
  return normalizeUserScope(scope) === expected;
}
